import { render, staticRenderFns } from "./ModelSelectbox.vue?vue&type=template&id=002206b7"
import script from "./ModelSelectbox.vue?vue&type=script&lang=js"
export * from "./ModelSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports